require("./o-timeline.scss");

// animation
var $ = require("jquery"),
    $timelineItem = $('.o-timeline__list-item'),
    $timelineItemContent = '.o-timeline__list-item-content',
    $timelineItemBullet = '.o-timeline__list-item-bullet',
    $timelineItemRange = $('.o-timeline__list-item-range-lines'),
    $timelineEnd = $('.o-timeline__end'),
    timelineItemContentHidden = 'o-timeline__list-item-content--hidden',
    timelineItemContentFadeIn = 'o-timeline__list-item-content--fade-in',
    timelineItemBulletHidden = 'o-timeline__list-item-bullet--hidden',
    timelineItemBulletBounceIn = 'o-timeline__list-item-bullet--bounce-in',
    timelineItemRangeHidden = 'o-timeline__list-item-range-lines--hidden',
    timelineItemRangeBounceIn = 'o-timeline__list-item-range-lines--bounce-in',
    timelineEndHidden = 'o-timeline__end--hidden',
    timelineEndBounceIn = 'o-timeline__end--bounce-in';

// hide
$timelineItem.each(function () {
    if ($(this).offset().top > $(window).scrollTop() + $(window).height() * 0.75) {
        $(this).find($timelineItemContent).addClass(timelineItemContentHidden);
        $(this).find($timelineItemBullet).addClass(timelineItemBulletHidden);
    }
});
$timelineItemRange.each(function () {
    if ($(this).offset().top > $(window).scrollTop() + $(window).height() * 0.75) {
        $(this).addClass(timelineItemRangeHidden);
    }
});
$timelineEnd.each(function () {
    if ($(this).offset().top > $(window).scrollTop() + $(window).height() * 0.75) {
        $(this).addClass(timelineEndHidden);
    }
});

// show
$(window).on('scroll', function () {
    $timelineItem.each(function () {
        if ($(this).offset().top <= $(window).scrollTop() + $(window).height() * 0.75 && $(this).find($timelineItemContent).hasClass(timelineItemContentHidden)) {
            $(this).find($timelineItemContent).removeClass(timelineItemContentHidden).addClass(timelineItemContentFadeIn);
            $(this).find($timelineItemBullet).removeClass(timelineItemBulletHidden).addClass(timelineItemBulletBounceIn);
        }
    });
    $timelineItemRange.each(function () {
        if ($(this).offset().top <= $(window).scrollTop() + $(window).height() * 0.75 && $(this).hasClass(timelineItemRangeHidden)) {
            $(this).removeClass(timelineItemRangeHidden).addClass(timelineItemRangeBounceIn);
        }
    });
    $timelineEnd.each(function () {
        if ($(this).offset().top <= $(window).scrollTop() + $(window).height() * 0.75 && $(this).hasClass(timelineEndHidden)) {
            $(this).removeClass(timelineEndHidden).addClass(timelineEndBounceIn);
        }
    });
});



// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-timeline/o-timeline.chunk.js